module.exports = __webpack_public_path__ + "img/Joe Schweitzer.d251eb85.jpg";